import React, { useEffect, useState } from "react";
import { PageHeader, EmptyState, Modal, Toast } from "@/components/Layout";
import { EmployerFields } from "@/pages/core/Licenses";
import api from "@/lib/api";

export default function Clients() {
  const [rows, setRows] = useState(null);
  const [editing, setEditing] = useState(null);
  const [flagsFor, setFlagsFor] = useState(null);   // { cui, name, catalog, flags } — comutatoarele clientului
  const [flagsSaving, setFlagsSaving] = useState(false);
  const [msg, setMsg] = useState({text:"",type:"info"});

  const load = () => api.get("/clients").then(r => setRows(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!editing.company_name?.trim()) return setMsg({text:"Denumirea companiei este obligatorie",type:"error"});
    try {
      await api.put(`/clients/${encodeURIComponent(editing.cui)}`, editing);
      setEditing(null); load();
      setMsg({text:"Client actualizat — modificările ajung la instalarea clientului la următoarea sincronizare",type:"success"});
      setTimeout(()=>setMsg({text:""}),4000);
    } catch(e) { setMsg({text:e?.response?.data?.detail||"Eroare",type:"error"}); }
  };

  const openFlags = async (c) => {
    try {
      const r = (await api.get(`/client-settings/${encodeURIComponent(c.cui)}`)).data;
      setFlagsFor({ cui: c.cui, name: c.company_name, catalog: r.catalog, flags: r.effective });
    } catch (e) { setMsg({text: e?.response?.data?.detail || "Eroare la încărcarea comutatoarelor", type: "error"}); }
  };
  const saveFlags = async () => {
    setFlagsSaving(true);
    try {
      await api.put(`/client-settings/${encodeURIComponent(flagsFor.cui)}`, { feature_flags: flagsFor.flags });
      setFlagsFor(null);
      setMsg({text:"Comutatoare salvate — ajung la instalarea clientului la următoarea sincronizare (maxim 6 ore) sau imediat prin „Sincronizează acum”",type:"success"});
      setTimeout(()=>setMsg({text:""}),5000);
    } catch (e) { setMsg({text: e?.response?.data?.detail || "Eroare la salvare", type: "error"}); }
    finally { setFlagsSaving(false); }
  };

  if (!rows) return <div>Se încarcă...</div>;

  return (
    <>
      <PageHeader title="Lista Angajatori/Clienți" subtitle={`${rows.length} clienți definiți`} />
      <Toast msg={msg.text} type={msg.type} />
      <div style={{display:"grid",gap:12}}>
        {rows.map(c => (
          <div key={c.id} className="card fade-up" style={{padding:20}} data-testid={`client-row-${c.cui}`}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12}}>
              <div style={{flex:1}}>
                <div style={{fontSize:16,fontWeight:700,color:"var(--navy)"}}>
                  {c.company_name} <span style={{fontSize:12,fontWeight:400,color:"#64748B"}}>CUI: {c.cui}</span>
                </div>
                {c.contact_email && <div style={{fontSize:12,color:"#64748B",marginTop:2}}>{c.contact_email}</div>}
                {(c.employer_address || c.legal_representative_name) && (
                  <div style={{fontSize:12,color:"#64748B",marginTop:4}}>
                    {c.employer_address}
                    {c.employer_address && c.legal_representative_name && " · "}
                    {c.legal_representative_name && `${c.legal_representative_name}${c.legal_representative_title ? `, ${c.legal_representative_title}` : ""}`}
                  </div>
                )}
                {c.notes && <div style={{marginTop:6,fontSize:12,color:"#64748B",fontStyle:"italic"}}>{c.notes}</div>}
                <div style={{fontSize:11,color:"#94A3B8",marginTop:6}}>Definit la: {(c.created_at||"").slice(0,10)}</div>
              </div>
              <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:8}}>
                {c.active_license_count > 0 ? (
                  <span className="badge badge-active" data-testid={`client-status-${c.cui}`}>
                    {c.active_license_count} licenț{c.active_license_count===1?"ă activă":"e active"}
                  </span>
                ) : c.license_count > 0 ? (
                  <span className="badge badge-inactive" data-testid={`client-status-${c.cui}`}>Fără licență activă</span>
                ) : (
                  <span className="badge badge-inactive" data-testid={`client-status-${c.cui}`}>Nicio licență</span>
                )}
                <div style={{display:"flex",gap:6}}>
                  <button className="btn btn-secondary" style={{padding:"3px 10px",fontSize:12}}
                    onClick={()=>openFlags(c)} data-testid={`flags-client-${c.cui}`}>Comutatoare</button>
                  <button className="btn btn-secondary" style={{padding:"3px 10px",fontSize:12}}
                    onClick={()=>setEditing({...c})} data-testid={`edit-client-${c.cui}`}>Editează</button>
                </div>
              </div>
            </div>
          </div>
        ))}
        {rows.length===0 && <EmptyState text='Niciun client definit încă. Mergi la "Emitere Licențe" > "+ Client nou".' />}
      </div>

      {flagsFor && (
        <Modal title={`Comutatoare — ${flagsFor.name} (CUI ${flagsFor.cui})`} onClose={()=>setFlagsFor(null)} width={620}>
          <div style={{fontSize:12,color:"#64748B",marginBottom:12}}>
            Funcții specifice acestui client. Codul e același pentru toți clienții; un comutator oprit lasă funcția invizibilă la acest client.
            Se aplică la instalarea lui la următoarea sincronizare.
          </div>
          {flagsFor.catalog.length === 0 && <EmptyState text="Nu există comutatoare definite în catalog." />}
          <div style={{display:"grid",gap:10}}>
            {flagsFor.catalog.map(f => (
              <label key={f.key} style={{display:"flex",gap:10,alignItems:"flex-start",cursor:"pointer"}}>
                <input type="checkbox" style={{marginTop:3}} checked={!!flagsFor.flags[f.key]}
                  onChange={e=>setFlagsFor({...flagsFor, flags: {...flagsFor.flags, [f.key]: e.target.checked}})}
                  data-testid={`flag-${f.key}`} />
                <span><b>{f.label}</b>
                  <div style={{fontSize:12,color:"#64748B"}}>{f.description}</div>
                  <div style={{fontSize:11,color:"#94A3B8"}} className="tabular-nums">{f.key}</div></span>
              </label>
            ))}
          </div>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:16}}>
            <button className="btn btn-secondary" onClick={()=>setFlagsFor(null)}>Anulează</button>
            <button className="btn btn-primary" onClick={saveFlags} disabled={flagsSaving || flagsFor.catalog.length===0} data-testid="save-flags">Salvează</button>
          </div>
        </Modal>
      )}

      {editing && (
        <Modal title={`Editează client — CUI ${editing.cui}`} onClose={()=>setEditing(null)}>
          <div style={{display:"grid",gap:12}}>
            <div><label className="label label-req">Companie / Angajator</label>
              <input className="input" value={editing.company_name||""}
                onChange={e=>setEditing({...editing,company_name:e.target.value})} data-testid="edit-client-company" /></div>
            <div style={{fontSize:11,color:"#64748B"}}>CUI-ul nu se poate modifica — e cheia licențelor emise.</div>
            <div><label className="label">Email contact (persoana ta de contact la client, pentru licențiere)</label>
              <input className="input" value={editing.contact_email||""}
                onChange={e=>setEditing({...editing,contact_email:e.target.value})} /></div>
            <div><label className="label">Note</label>
              <textarea className="textarea" rows={2} value={editing.notes||""}
                onChange={e=>setEditing({...editing,notes:e.target.value})} /></div>
            <EmployerFields value={editing} onChange={setEditing} />
            <div style={{fontSize:11,color:"#94A3B8"}}>
              Denumirea se actualizează pe instalarea clientului la următoarea sincronizare. Celelalte date ale
              angajatorului se aplică doar dacă angajatorul nu a fost încă creat acolo — după aceea le administrează Adminul clientului.
            </div>
          </div>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:16}}>
            <button className="btn btn-secondary" onClick={()=>setEditing(null)}>Anulează</button>
            <button className="btn btn-primary" onClick={save} data-testid="save-edit-client">Salvează</button>
          </div>
        </Modal>
      )}
    </>
  );
}
